@for (block of blocks; track block.id) {
    @switch (block.kind) {
        @case ('richText') {
            <section class="mp-content-block mp-content-block--text">
                @if (block.heading) { <h2>{{block.heading}}</h2> }
                @for (paragraph of block.paragraphs; track $index) { <p>{{paragraph}}</p> }
            </section>
        }
        @case ('metrics') {
            <section class="mp-content-block">
                @if (block.heading) { <h2>{{block.heading}}</h2> }
                <div class="mp-block-metrics">
                    @for (metric of block.items; track metric.label) {
                        <article><strong>{{metric.value}}</strong><span>{{metric.label}}</span></article>
                    }
                </div>
            </section>
        }
        @case ('featureList') {
            <section class="mp-content-block">
                @if (block.heading) { <h2>{{block.heading}}</h2> }
                <div class="mp-block-features">
                    @for (item of block.items; track item) {
                        <article><span aria-hidden="true">✓</span><p>{{item}}</p></article>
                    }
                </div>
            </section>
        }
        @case ('parts') {
            <section class="mp-content-block">
                @if (block.heading) { <h2>{{block.heading}}</h2> }
                <div class="mp-block-parts">
                    @for (part of block.items; track part.title) {
                        <article>
                            <span class="mp-block-part-kind mp-block-part-kind--{{part.kind}}">{{part.kind}}</span>
                            <h3>{{part.title}}</h3>
                            <p>{{part.description}}</p>
                        </article>
                    }
                </div>
            </section>
        }
        @case ('callout') {
            <aside class="mp-content-block mp-block-callout mp-block-callout--{{block.tone}}">
                @if (block.heading) { <h2>{{block.heading}}</h2> }
                <p>{{block.body}}</p>
            </aside>
        }
        @case ('image') {
            <section class="mp-content-block mp-block-image mp-block-image--{{block.width || 'content'}}">
                @if (block.heading) { <h2>{{block.heading}}</h2> }
                <figure>
                    <img [src]="block.image.src" [alt]="block.image.decorative ? '' : block.image.alt">
                    @if (block.image.caption) { <figcaption>{{block.image.caption}}</figcaption> }
                </figure>
            </section>
        }
        @case ('screenshotGallery') {
            <section class="mp-content-block">
                @if (block.heading) { <h2>{{block.heading}}</h2> }
                @if (block.intro) { <p class="mp-block-intro">{{block.intro}}</p> }
                <div class="mp-block-gallery">
                    @for (image of block.images; track image.src) {
                        <figure>
                            <div><img [src]="image.src" [alt]="image.decorative ? '' : image.alt"></div>
                            @if (image.caption) { <figcaption>{{image.caption}}</figcaption> }
                        </figure>
                    }
                </div>
            </section>
        }
        @case ('resourceLinks') {
            <section class="mp-content-block">
                @if (block.heading) { <h2>{{block.heading}}</h2> }
                @if (block.intro) { <p class="mp-block-intro">{{block.intro}}</p> }
                <div class="mp-block-resources">
                    @for (link of block.links; track link.url) {
                        <a [href]="link.url" target="_blank" rel="noopener noreferrer">
                            @if (link.source) { <span>{{link.source}}</span> }
                            <strong>{{link.title}} <span aria-hidden="true">↗</span></strong>
                            @if (link.description) { <p>{{link.description}}</p> }
                        </a>
                    }
                </div>
            </section>
        }
        @case ('steps') {
            <section class="mp-content-block">
                @if (block.heading) { <h2>{{block.heading}}</h2> }
                @if (block.intro) { <p class="mp-block-intro">{{block.intro}}</p> }
                <div class="mp-block-steps">
                    @for (item of block.items; track item; let index = $index) {
                        <article><span>{{index + 1}}</span><p>{{item}}</p></article>
                    }
                </div>
            </section>
        }
        @case ('bulletList') {
            <section class="mp-content-block mp-block-list">
                @if (block.heading) { <h2>{{block.heading}}</h2> }
                @if (block.intro) { <p class="mp-block-intro">{{block.intro}}</p> }
                <ul>
                    @for (item of block.items; track item) { <li>{{item}}</li> }
                </ul>
            </section>
        }
        @case ('maturity') {
            <section class="mp-content-block">
                @if (block.heading) { <h2>{{block.heading}}</h2> }
                <div class="mp-block-maturity">
                    @for (step of block.steps; track step) {
                        <div [class.active]="step === block.activeStep" [class.complete]="block.steps.indexOf(step) < block.steps.indexOf(block.activeStep)">
                            <span></span>
                            <strong>{{step}}</strong>
                            <small>{{step === block.activeStep ? 'We are here' : (block.steps.indexOf(step) < block.steps.indexOf(block.activeStep) ? 'Shaped' : 'Next')}}</small>
                        </div>
                    }
                </div>
            </section>
        }
        @case ('illustration') {
            <section class="mp-content-block">
                @if (block.heading) { <h2>{{block.heading}}</h2> }
                @if (block.description) { <p class="mp-block-intro">{{block.description}}</p> }
                @if (block.visual === 'loadProfile') {
                    <div class="mp-block-load-chart">
                        <div class="mp-block-load-chart__axis"><span>1000 users</span><span>500</span><span>0</span></div>
                        <svg viewBox="0 0 900 220" preserveAspectRatio="none" role="img" aria-label="Example load profile ramping from zero to one thousand virtual users">
                            <defs>
                                <linearGradient id="mpContentLoadGradient" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0" stop-color="#1496e6" stop-opacity=".28"></stop>
                                    <stop offset="1" stop-color="#1496e6" stop-opacity=".02"></stop>
                                </linearGradient>
                            </defs>
                            <path class="mp-block-load-chart__grid" d="M0 24 H900 M0 110 H900 M0 196 H900"></path>
                            <path class="mp-block-load-chart__area" d="M0 196 L100 168 L220 168 L340 108 L520 108 L650 40 L790 40 L900 196 Z"></path>
                            <path class="mp-block-load-chart__line" d="M0 196 L100 168 L220 168 L340 108 L520 108 L650 40 L790 40 L900 196"></path>
                        </svg>
                        <div class="mp-block-load-chart__labels"><span>Warm up</span><span>Sustained load</span><span>Peak</span><span>Cool down</span></div>
                    </div>
                }
            </section>
        }
    }
}
